import { Environment } from './contentstackEnvironment';
import { requireEnv } from './requireEnv';
import type { StackConfig } from './types';

/*
  Contentstack apiKeys and access tokens are for read-only access to published
  (publicly available) content only. They are sourced from environment variables
  (see each consuming app's SSM / Consul wiring); this package holds no literals.
*/
export const stackConfig: StackConfig = {
  DX: {
    get apiKey() {
      return requireEnv('CONTENTSTACK_STACK_API_KEY');
    },
    envs: {
      [Environment.Preview]: {
        name: 'preview',
        get token() {
          return requireEnv('CONTENTSTACK_PREVIEW_DELIVERY_TOKEN');
        },
      },
      [Environment.Qa]: {
        // No QA environment for DX, so use the Production name and token
        name: 'production',
        get token() {
          return requireEnv('CONTENTSTACK_PROD_DELIVERY_TOKEN');
        },
      },
      [Environment.Production]: {
        name: 'production',
        get token() {
          return requireEnv('CONTENTSTACK_PROD_DELIVERY_TOKEN');
        },
      },
    },
  },
};
